import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
const SingleTableEntry = ({ data1,resetValue }) => {
  const [data, setData] = useState([]);

  // console.log("data table------", data);
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const columns = useMemo(
    () => [
      {
        Header: "Mobile Number",
        Footer: "Mobile Number",
        accessor: "msisdn", // accessor is the "key" in the data
      },

      {
        Header: "Message",
        Footer: "Message",
        accessor: "message",
      },
      {
        Header: "Uploaded Date",
        Footer: "Uploaded Date",
        accessor: "uploadDate",
      },
  
    ],
    []
  );


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,   
     page,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
  );

 
  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  useEffect(() => {
    setData(data1);
  }, [data1]);
  useEffect(() => {
    setData([]);
  }, [resetValue]);
  return (
    <>
      <div>
        <div className="card-body p-0">
        {
          data.length>0 && (
            <>
            <div className="container-fluid p-0">
            <div className="card shadow-none border bg_blue mt-5">
              <span className="badge rounded-pill bg-primary mt-n3 ms-5 ">
                Number List
              </span>
              <div className="p-4">
                <div>
                  {selectedFlatRows.length > 0 && (
                    <button onClick={deletUser}>Delete Users</button>
                  )}
                </div>

                <table
                  {...getTableProps()}
                  id="example"
                  className="table table-striped table-bordered dataTable table-sm"
                  style={{ width: "100%" }}
                >
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th
                            {...column.getHeaderProps(
                              column.getSortByToggleProps()
                            )}
                            className="text-center width_2"
                          >
                            {column.render("Header")}
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? "↑"
                                  : "↓"
                                : ""}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {/* {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} className="text-center">
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })} */}

                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => {
                            return (
                              <td
                                {...cell.getCellProps()}
                                className={
                                          (cell.column.Header == "Mobile Number" ||
                                            cell.column.Header ==
                                              "") &&
                                          "text-end"
                                        }
                              >
                                {cell.render("Cell")}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                  {/* <tfoot>
            {footerGroups.map((footerGroup) => (
              <tr {...footerGroup.getFooterGroupProps()}>
                {footerGroup.headers.map((column) => (
                  <td className="text-center" {...column.getFooterProps}>
                    {column.render("Footer")}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot> */}
                </table>
              </div>
            </div>
          </div>
            </>
          )
        }
         
        </div>
      </div>
    </>
  );
};

export default SingleTableEntry;
